import { render, staticRenderFns } from "./AbstractBatchReview.vue?vue&type=template&id=77333d97"
import script from "./AbstractBatchReview.vue?vue&type=script&lang=js"
export * from "./AbstractBatchReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports